<template>
  <vue-editor
    useCustomImageHandler
    @image-added="handleImageAdded"
    v-model="content"
    @input="handleInput"
    :editorToolbar="customToolbar"
  ></vue-editor>
</template>

<script>
import ApiService from "@/common/api.service";
import { API_UPLOADS } from "@/common/config";
import { VueEditor, Quill } from "vue2-editor";

export default {
  props: ["value"],
  components: {
    "vue-editor": VueEditor
  },
  created() {
    this.content = this.value;
  },
  data() {
    return {
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        ["link", "image", "video", "formula"],
        [{ direction: "rtl" }]
      ],
      content: this.value
    };
  },
  methods: {
    handleInput(e) {
      this.$root.$emit("vue-editor", this.content + " ");
    },
    handleImageAdded(file, Editor, cursorLocation) {
      var formData = new FormData();
      formData.append("file", file);

      ApiService.post("upload/galeries", formData)
        .then(result => {
          let url = result.data;
          Editor.insertEmbed(cursorLocation, "image", API_UPLOADS + url);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_commons/vue-editor.vue